// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3IOzd","buttons":"RemoveExpirationActionButtons_buttons__2Aib_"};